<template>
	<BasePublishDetail v-slot="{item}">
		<CmsPageHeader class="pd-header" :class="{'noimage': !item.main_image_upload_path}" :image="item.main_image_thumbs?.['width1400-height690-crop1']?.thumb ? absoluteImagePath(item.main_image_thumbs['width1400-height690-crop1'].thumb) : ''" mode="publishgDetail">
			<CmsBreadcrumbs :items="item.breadcrumbs" class="pd-bc" />
			<h1 class="pd-title">{{ item.seo_h1 }}</h1>
		</CmsPageHeader>

		<div class="wrapper pd-hero-image" v-if="item.main_image_upload_path">
			<BaseUiImage :data="item.main_image_thumbs?.['width1400-height690-crop1']" :alt="item.main_image_description || item.seo_h1" :title="item.main_image_title" />
		</div>
		<div class="pd-wrapper">
			<div class="pd-date"><BaseUtilsFormatDate :date="item.datetime_published" format="DD. MMMM YYYY." /></div>
			<div class="cms-content">
				<div class="pd-content" v-if="item.content" v-html="item.content" v-interpolation></div>
				<ul class="pd-documents" v-if="item.documents?.length">
					<li v-for="document in item.documents" :key="document.id">
						<a :href="document.url" target="_blank">{{document.title || document.url}}</a>
					</li>
				</ul>
				
				<template v-if="item.images?.length > 1">
					<BaseUiImages :images="item.images" v-slot="{items: images}" :exclude="1">
						<div class="pd-thumbs" v-if="images?.length">
							<div class="pd-thumb" v-for="image in images" :key="image.id">
								<BaseUiImage class="image-border" loading="lazy" :data="image.file_thumbs?.['width790-height390-crop1']" default="/images/no-image.jpg" :alt="image.description" :title="image.title" />
							</div>
						</div>
					</BaseUiImages>
				</template>
			</div>

			<CmsShare />
		</div>

		<BasePublishPostsWidget :fetch="{category_code: item.category_code, id_exclude: item.id, limit: 6}" v-slot="{items}">
			<LazyPublishSpecialPosts :items="items" v-if="items?.length">
				<template #header>
					<BaseCmsLabel code="special_posts" />
				</template>
				<template #items="{item}">
					<PublishIndexEntry :item="item" class="pp-special" />
				</template>
				<template #footer>
					<NuxtLink class="btn" :to="item.category_url_without_domain"><BaseCmsLabel code="show_all_posts" /></NuxtLink>
				</template>
			</LazyPublishSpecialPosts>
		</BasePublishPostsWidget>
	</BasePublishDetail>
</template>

<script setup>
	const {absoluteImagePath} = useText();
</script>

<style lang="less" scoped>
	.pd-title{
		max-width: none; width: 800px; margin: auto;
		@media (max-width: @m){width: 100%;}	
	}
	.pd-hero-image{
		margin-top: -550px; position: relative; z-index: 1; padding-bottom: 25px;
		:deep(img){border-radius: 20px; display: block; margin: auto;}
		@media (max-width: @l){margin-top: -470px;}
		@media (max-width: @t){margin-top: 0;}
		@media (max-width: @m){
			padding-bottom: 16px;
			:deep(img){border-radius: 10px;}	
		}
	}
	.pd-date{
		color: var(--darkGray); font-size: 14px; margin-bottom: 20px; position: relative; display: flex; align-items: center;
		&:before{.icon-edit2(); font: 17px/1 var(--fonti); margin-right: 10px;}
		@media (max-width: @m){
			font-size: 12px; margin-bottom: 14px;
			&:before{margin-right: 6px;}	
		}
	}
	.pd-thumb{
		padding-bottom: 20px; line-height: 0;
		@media (max-width: @m){padding-bottom: 10px;}
	}
	.pd-wrapper{
		width: 760px; margin: auto; padding-bottom: 65px;
		@media (max-width: @m){width: 100%; padding: 0 16px 32px;}	
	}
	:deep(.swiper-button){
		top: calc(~"((100vw - (var(--wrapperPadding) * 2) - 60px) / 3) / 3.4 - 22px");
		@media (max-width: @t){top: calc(~"((100vw - (var(--wrapperPadding) * 2) - 60px) / 3) / 3.4 - 12px");}	
	}
	.pd-documents{padding-top: 20px;}
</style>
